import React from 'react';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h1>Система управления нормативными документами по ИБ</h1>
        <p>Сайт находится в разработке</p>
      </header>
    </div>
  );
}

export default App;
